import React from "react";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

export const tableConstants = (permissions, timeTableDelete) => {
  let count = 1;
  let formatedData = [
    {
      title: 'SNo',
      render: () => {
        return <span>{count++}</span>;
      },
    },
    {
      title: 'Subject',
      render: rowData => {
        return <div>{rowData.class_time_table_programs[0].subject.name}</div>
      },
    },
    {
      title: 'day',
      render: rowData => {
        return <span>{rowData.day}</span>;
      },
    },
    {
      title: 'Start Time',
      render: rowData => {
        return <span>{rowData.start_time}</span>;
      },
    },
    {
      title: 'End Time',
      render: rowData => {
        return <span>{rowData.end_time}</span>;
      },
    },
    {
      title: 'class',
      render: rowData => {
        return <div>{rowData.class_time_table_programs.map((item, idx) => <span key={idx}>{item.program.name}, </span>)}</div>;
      },
    },
    {
      title: 'Action',
      render: rowData => {
        return <span>
          {permissions.includes('time_table.update') &&
            <Link to={`/timetable/update/${rowData.id}`}>
              <FontAwesomeIcon
                icon={faEdit}
                style={{
                  color: "var(--color-primary-text)",
                  marginRight: "10px",
                  cursor: "pointer"
                }}
              />
            </Link>
          }
          &nbsp;
          {permissions.includes("time_table.delete") &&
            <span
              className="cursor-pointer"
              onClick={() => {
                if (window.confirm(`Are you sure you wish to delete this item?`))
                  timeTableDelete(rowData.id)
              }}>
              <i className="fa fa-trash text-danger"></i>
            </span>
          }
        </span>;
      },
    },
  ];
  return formatedData;
};
